import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { LoginVM } from 'src/app/models/Registration';
import { AuthService } from 'src/app/core-services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  forgotForm: FormGroup;
  submitted: boolean = false;
  loading: boolean = false;
  isSuccess: boolean = false;
  constructor(private fb: FormBuilder, private authenticationService: AuthService, private toastr: ToastrService,
     private router: Router) {
    this.forgotForm = this.fb.group({
      userName: ['', [Validators.required, Validators.email]]
    });
  }

  ngOnInit() {
  }

  public hasError = (controlName: string, errorName: string) => {
    return this.forgotForm.controls[controlName].hasError(errorName);
  }

  sendEmail() {
    this.submitted = true;
    if (this.forgotForm.invalid) {
      return;
    }
    else {
      let model: LoginVM;
      model = this.forgotForm.value;
      this.loading = true;
      this.authenticationService.forgotPassword(model).subscribe((response: any) => {
        if (response != null && response.isSuccess == true) {
           // this.toastr.info('Email sent successfully, please check your email.')
            // this.forgotForm.reset();
            this.isSuccess = true;
        }
        else {
          this.toastr.warning(response.message);
        }
      })
    }
  }

}
